var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C00",
  fillRule: "evenodd",
  d: "M6.72 15.825c.145.11.313.175.506.175a.8.8 0 0 0 .53-.197l5.545-5.35c.265-.262.265-.655 0-.895l-5.544-5.35a.75.75 0 0 0-1.013-.022.593.593 0 0 0-.024.917l5.062 4.892-5.086 4.913c-.265.262-.265.677.024.917"
}))));
export default SvgCaretRight;